import { render, staticRenderFns } from "./AddNewsPopup.vue?vue&type=template&id=4dc50601"
import script from "./AddNewsPopup.vue?vue&type=script&lang=js"
export * from "./AddNewsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports